module.exports = __webpack_public_path__ + "img/target.52f65521.svg";